import EventTypes from './types';

// The access selects (levels, groups, tiers) hold options plus two special
// ones: "N/A" (value null: not open to anyone by this field) and "All ..."
// (value []: open to everyone). Events and series store them as null, [] or
// a list: level and group names, tier ids.

const toAccessList = (selectedArray, mapItem) => {
  if (!selectedArray || selectedArray.length === 0) {
    return null;
  }
  const valueArray =
    Array.isArray(selectedArray) && selectedArray.map(({ value }) => value);
  const containsForAll =
    Array.isArray(selectedArray) &&
    valueArray.some((item) => Array.isArray(item));
  const containsNotApplicable =
    Array.isArray(selectedArray) && valueArray.some((item) => !item);
  if (containsForAll) {
    return [];
  }
  if (containsNotApplicable) {
    return null;
  }
  if (Array.isArray(selectedArray)) {
    return selectedArray.map(mapItem);
  }
  return null;
};

export const filterGroupsLevels = (selectedArray, targetAudience) => {
  if (EventTypes.TargetAudience.private === targetAudience) return null;
  return toAccessList(selectedArray, (item) => item.label);
};

export const filterTiers = (selectedArray, targetAudience) => {
  if (EventTypes.TargetAudience.partner === targetAudience) return null;
  return toAccessList(selectedArray, (item) => item.value);
};

// The other way: a stored list as the select's value. byValue: match options
// by value (tiers) instead of by label (levels and groups).
export const accessToOptions = (
  selectedArray,
  options,
  { notApplicable, allAllowed, byValue = false }
) => {
  if (selectedArray === null || selectedArray === undefined) {
    return [notApplicable];
  }
  if (selectedArray.length === 0) {
    return [allAllowed];
  }
  return options.filter((option) =>
    selectedArray.includes(byValue ? option.value : option.label)
  );
};
